import React, { useContext, useEffect, useState } from 'react'
import QuestionComponent from './QuestionComponent';
import {  firestore, getFullHttpUrl } from '../../../../firebase.config';
import { DataContext } from '../../../../Context/DataContext';

import TeamInviteComponent from './TeamInviteComponent';
import { useScreenTransition } from '../../../../Hooks/useScreenTransition';
import { NotificationContext } from '../../../../Context/NotificationContext';
import axios from 'axios';


const question =  {
    title: "4. Teammate Invite",
    question: "Would you like to invite a teammate to explore with you?",
    options: "",
}

const Ques4 = ({windowSize, currentScreen, setCurrentScreen, onContinue}) => {
    const {userData, teamData} = useContext(DataContext);
    const [invitedMembers, setInvitedMembers] = useState([]);
    const [sendInvitesBtnText, setSendInvitesBtnText] = useState("Send Invites");
    const { transitionTo } = useScreenTransition();

    const {showNotification} = useContext(NotificationContext);
    
    useEffect(() => {
      if(invitedMembers.length > 0) {
        const invitedMembers = localStorage.getItem("invitedMembers");
        if(invitedMembers) {
          setInvitedMembers(JSON.parse(invitedMembers));
        }
      }
    }, [])

    useEffect(() => {
        if(userData && userData.teamId && teamData){
          const onBoarding = teamData.onBoarding;
          if(!onBoarding || !onBoarding.translation_workflow){
            transitionTo(`/account/onboarding?step=1`);
            return;
          }
          if(!onBoarding || !onBoarding.immigration_platforms){
            transitionTo(`/account/onboarding?step=2`);
            return;
          }
          if(!onBoarding || !onBoarding.team_size){
            transitionTo(`/account/onboarding?step=3`);
            return;
          }
        }
      }, [userData, teamData])

      const onContinueQuestion = (teamCollaborator = false) => {
        firestore.collection("teams").doc(userData.teamId).update({onBoarding: {...teamData.onBoarding, early_team_collaborator: teamCollaborator}}).then(() => {
            onContinue();
        })
      }

      const addMember = async() => {

        setSendInvitesBtnText("Sending...");
        if(invitedMembers.length === 0) {
            showNotification("Error", "Please, add at least one member.", "error");
            setSendInvitesBtnText("Send Invites");
            return;
        }

        invitedMembers.forEach(async (member) => {
          await axios({
              method: "post",
              url: getFullHttpUrl("team-inviteMember"),
              data: member,
            }).then((res) => {
              setSendInvitesBtnText("Send Invites");
              onContinueQuestion(true);
            }).catch((err) => {
              setSendInvitesBtnText("Send Invites");
              showNotification("Error", "There was an error. Please, try again or refresh the page.", "error");
            })
        })
    }

  return (

    <QuestionComponent
    windowSize={windowSize}
    question={question.question}
    onContinue={addMember}
    onContinueBtnText={sendInvitesBtnText}
    progressTitle={question.title}
    progress={3}
    onBack={() => onContinueQuestion(false)}
    backBTnText="Skip"
    disableContinue={invitedMembers.length === 0}
  >
    <div className={`flex gap-[16px] w-full flex-wrap`}>
      <TeamInviteComponent setInvitedMembers={setInvitedMembers} invitedMembers={invitedMembers}/>
    </div>
  </QuestionComponent>
  )
}

export default Ques4;